/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A User event
 * @export
 * @interface ApiUserEvent
 */
export interface ApiUserEvent {
    /**
     * 
     * @type {string}
     * @memberof ApiUserEvent
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof ApiUserEvent
     */
    metadata?: object;
}

/**
 * Check if a given object implements the ApiUserEvent interface.
 */
export function instanceOfApiUserEvent(value: object): value is ApiUserEvent {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ApiUserEventFromJSON(json: any): ApiUserEvent {
    return ApiUserEventFromJSONTyped(json, false);
}

export function ApiUserEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function ApiUserEventToJSON(json: any): ApiUserEvent {
    return ApiUserEventToJSONTyped(json, false);
}

export function ApiUserEventToJSONTyped(value?: ApiUserEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'metadata': value['metadata'],
    };
}

